const LOCALE = 'tr-TR'

const isHeading = (text) => Boolean(text)
  && text.length < 60
  && /\p{L}/u.test(text)
  && text === text.toLocaleUpperCase(LOCALE)

const isBlank = (node) => node.nodeName === 'BR' || (node.nodeType === 3 && !node.textContent.trim())

function trimBreaks(element) {
  while (element.firstChild && isBlank(element.firstChild)) element.firstChild.remove()
  while (element.lastChild && isBlank(element.lastChild)) element.lastChild.remove()
}

function dropLeadingHeading(body) {
  const first = body.firstElementChild
  if (!first) return
  const text = first.textContent.trim()
  if (isHeading(text)) {
    first.remove()
    return
  }
  const lead = first.firstElementChild
  if (!lead || !/^(STRONG|B)$/.test(lead.nodeName)) return
  const leadText = lead.textContent.trim()
  if (!isHeading(leadText) || !text.startsWith(leadText)) return
  lead.remove()
  trimBreaks(first)
}

// Cleans markup pasted from the old CMS: inline font sizes, Word comments, empty paragraphs.
export function cleanHtml(html, { dropHeading = false } = {}) {
  if (!html || typeof DOMParser === 'undefined') return ''
  const doc = new DOMParser().parseFromString(String(html), 'text/html')
  const { body } = doc

  const comments = doc.createTreeWalker(body, NodeFilter.SHOW_COMMENT)
  const stale = []
  while (comments.nextNode()) stale.push(comments.currentNode)
  stale.forEach((node) => node.remove())

  body.querySelectorAll('script, style, iframe, object').forEach((node) => node.remove())
  body.querySelectorAll('*').forEach((node) => {
    ;[...node.attributes].forEach((attr) => {
      if (attr.name !== 'href') node.removeAttribute(attr.name)
    })
  })
  body.querySelectorAll('a').forEach((link) => {
    link.setAttribute('target', '_blank')
    link.setAttribute('rel', 'noreferrer')
  })
  body.querySelectorAll('span, font').forEach((node) => node.replaceWith(...node.childNodes))
  body.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach((node) => {
    const heading = doc.createElement('h3')
    heading.append(...node.childNodes)
    node.replaceWith(heading)
  })

  const texts = doc.createTreeWalker(body, NodeFilter.SHOW_TEXT)
  while (texts.nextNode()) {
    texts.currentNode.textContent = texts.currentNode.textContent.replace(/[\u00a0\s]+/g, ' ')
  }

  body.querySelectorAll('p, h3').forEach((node) => {
    trimBreaks(node)
    if (!node.textContent.trim() && !node.querySelector('img')) node.remove()
  })

  if (dropHeading) dropLeadingHeading(body)
  return body.innerHTML.trim()
}
